export default "De kaart toont per jaar het jaargemiddelde in mg/l. De jaargemiddelden zijn berekend tot en met het meest recente beschikbare meetjaar.\n";